<template>
  <div class="relation-graph-container" ref="graphContainer" :class="[open_ability == 1 ? 'showAbility' : '']">
    <div class="loading-wrapper" v-if="loading">
      <a-spin tip="图谱加载中......">
        <a-icon slot="indicator" type="loading" wrapperClassName="loading-wrapper" />
      </a-spin>
    </div>
    <Header></Header>
    <!-- 切换布局方式 -->
    <div class="toggle-layout" :class="`layoutType-${layoutType}`">
      <div class="toggle-item" :class="{ active: layoutType == 1 }" @click="toggleLayout(1)">中心布局</div>
      <div class="toggle-item" :class="{ active: layoutType == 2 }" @click="toggleLayout(2)">树形布局</div>
    </div>
    <!-- 筛选项 -->
    <template>
      <!-- 专业能力图谱筛选项 -->
      <div class="major-graph" v-if="open_ability == 1">
        <div class="major-filter">
          <input placeholder="思政元素关键词搜索" type="text" class="filter-input" v-model="major_keyword">
          <div class="filter-button" @click="handleFilter()">筛选</div>
        </div>
        <div class="major-list">
          <div class="school-item" :class="{ up: item.expand }" v-for="item, index in filterData"
            :key="'school-' + index">
            <div class="school-header" @click="majorExpand(index)">
              <div class="header-name">{{ item.name }}</div>
              <div class="header-expand"></div>
            </div>
            <div class="school-major" :class="{ 'expanded': item.expand }"
              :style="{ height: item.expand ? '0px' : item.contentHeight + 'px' }" ref="majorContents">
              <div class="major-item" v-for="item, index in item.children" :key="'major-' + index"
                @click="handleSelect(item)" :class="{ active: item.id == major_id }">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 系统默认形式筛选项 -->
      <div class="graph-filter" v-else>
        <!-- 专业大类 -->
        <div class="filter-item" :class="{ active: subject_big_id }">
          <a-select dropdownClassName="graph-select-drop" :notFoundContent="'暂无数据'" placeholder="全部专业大类"
            v-model="subject_big_id" @change="subjectBigChange()">
            <a-select-option v-for="item, index in subjectBigData" :key="index" :value="item.id">{{ item.name
            }}</a-select-option>
          </a-select>
        </div>
        <!-- 专业小类 -->
        <div class="filter-item" :class="{ active: subject_small_id }">
          <a-select dropdownClassName="graph-select-drop" :notFoundContent="'请先选择专业大类'" placeholder="全部专业小类"
            v-model="subject_small_id" @change="subjectSmallChange()">
            <a-select-option v-for="item, index in subjectSmallData" :key="index" :value="item.id">{{ item.name
            }}</a-select-option>
          </a-select>
        </div>
        <!-- 专业 -->
        <div class="filter-item" :class="{ active: subject_major_id }">
          <a-select dropdownClassName="graph-select-drop" :notFoundContent="'请先选择专业小类'" placeholder="全部专业"
            v-model="subject_major_id">
            <a-select-option v-for="item, index in subjectfilterData" :key="index" :value="item.id">{{ item.name
            }}</a-select-option>
          </a-select>
        </div>
        <!-- 关键词 -->
        <div class="filter-item">
          <a-input placeholder="思政元素关键词" v-model="keyword" @keydown.enter="handleFilter()"></a-input>
        </div>

        <div class="handle-group">
          <div class="handle-item" @click="handleReset()">重置</div>
          <div class="handle-item" @click="handleFilter()">筛选</div>
        </div>
      </div>

    </template>
    <div v-show="selectNode" class="grap-details-expand" @click="handleExpand(0)">展开</div>
    <!-- 右侧详情信息 -->
    <div class="grap-details" :class="[`expand-status-${expandValue}`]" v-if="selectNode">
      <div class="detail-header">
        <div class="button-item expand" @click="handleExpand(1, true)">展开</div>
        <div class="detail-name">{{ findName(selectNode.id) || detailContent.name }}</div>
        <div class="button-item put" @click="handleExpand(-1, true)">收起</div>
      </div>
      <div class="detail-content">
        <div class="scroll">
          <!-- 思政元素说明 -->
          <div class="item-text" v-if="detailContent.abstract">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">思政元素说明</div>
              </div>
            </div>
            <div class="block-content">
              <p>
                {{ detailContent.abstract }}
              </p>
            </div>
          </div>
          <!-- 内涵理解 -->
          <div class="connotation-box" v-if="connotation">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">思政元素内涵理解</div>
              </div>
              <div class="block-button" @click="handleNhljDetail()">查看详情</div>
            </div>
            <div class="block-content">
              <p>
                {{ connotation }}
              </p>
            </div>
          </div>
          <!-- 思政元素资源 -->
          <div class="szyszy-box" v-if="szyszyData && szyszyData.length > 0">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">相关课程思政元素资源</div>
                <div class="block-num">(共{{ szyszyTotal }}条)</div>
              </div>
              <div class="block-button" @click="szyszyMore()">查看更多</div>
            </div>
            <div class="block-content">
              <a class="res-item" :class="item.type == 1 ? 'word' : 'video'" v-for="item, index in szyszyData"
                :key="'szyszyData_' + index" :title="item.title" @click.prevent="goSzyszyDetails(item)">
                <!-- <div > -->
                <div class="res-info">
                  <div class="res-title">
                    {{ item.title }}
                  </div>
                  <div class="res-type" v-if="item.is_school_original == 1"></div>
                </div>
                <div class="res-suggest" v-if="item.suggest_list && item.suggest_list.length > 0">应用建议：<span
                    v-for="suggest_item, suggest_index in item.suggest_list" :key="'suggest_' + suggest_index">{{
                      suggest_item.name }}
                    <i v-if="suggest_index + 1 != item.suggest_list.length">、</i></span></div>
                <!-- </div> -->
              </a>

            </div>
          </div>
          <!-- 适用专业 -->
          <div class="syzy-box" v-if="fitMajor && fitMajor.length > 0">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">思政元素适用专业</div>
              </div>
              <div class="swiper-handle">
                <div class="swiper-button-prev"></div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-next"></div>
              </div>
            </div>
            <div class="block-content">
              <div class="swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" :data-id="item.id" :data-pid="item.pid" :data-classname="item.classname"
                    :class="item.classname" v-for="(item, index) in fitMajor" :key="index">
                    {{ item.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 案例资源 -->
          <div class="alzy-box" v-if="alzyData && alzyData.length > 0">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">案例资源</div>
                <div class="block-num">(共{{ alzyTotal }}条)</div>
              </div>
              <div class="block-button" @click="toAlzyDetail('/zy/alzyk')">查看更多</div>
            </div>
            <div class="block-content">
              <div class="kcszal_item" v-for="item, index in alzyData" :key="index" @click="getzyalInfo(item.id)">
                <div class="item_img">
                  <div :style="`background: url(${item.cover}) no-repeat center/cover;`"></div>
                </div>
                <div class="item_info">
                  <div class="item_title">
                    {{ item.name }}
                  </div>
                  <div class="item_keyword">
                    {{ item.tags.join(" | ") }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 专业定位 -->
          <div class="item-text" v-if="detailContent.position">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">专业定位</div>
              </div>
            </div>
            <div class="block-content">
              <p>
                {{ detailContent.position }}
              </p>
            </div>
          </div>
          <!-- 专业育人目标 -->
          <div class="item-text" v-if="detailContent.target">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">专业育人目标</div>
              </div>
            </div>
            <div class="block-content">
              <p>
                {{ detailContent.target }}
              </p>
            </div>
          </div>

          <!-- 适用的思政元素 -->
          <div class="item-text" v-if="showWordCloud">
            <div class="block-header">
              <div class="block-left">
                <div class="block-name">适用的思政元素</div>
              </div>
              <div class="block-button" @click="handleSzysMore()">查看更多</div>
            </div>
            <div class="block-content">
              <div class="wordCloud" ref="cloudChart"></div>
            </div>
          </div>

          <!-- 案例资源预览 -->
          <a-modal v-model="pdfVisible" title="资源预览" :afterClose="pdfCloseMadol" :footer="null" width="70vw"
            :centered="true">
            <iframe :src="pdfUrl" frameborder="0" width="100%" height="600px"></iframe>
            <div style="display: flex; justify-content: end; align-items: center">
              <template v-if="downloadList.some((item) => alzyInfoId == item)">
                <a-spin></a-spin>
                <div style="
                  font-size: 16px;
                  height: 40px;
                  padding: 0 20px;
                  line-height: 38px;
                  color: #1890ff;
                ">
                  下载中...
                </div>
              </template>
              <a-button type="link" size="large" @click="downloadpdf" v-else>下载</a-button>
            </div>
          </a-modal>

          <a-modal v-model="nhljModal" title="思政元素内涵理解" :afterClose="nhljCloseModal" :footer="null" width="70vw"
            :centered="true" class="nhljPreview">
            <iframe ref="myIframe" :src="nhljUrl" frameborder="0" width="100%" height="600px"></iframe>
          </a-modal>
        </div>
      </div>
    </div>
    <!-- 节点文本tooltip提示 -->
    <div v-if="isShowNodeTipsPanel" class="node-tooltip" :style="{
      left: nodeMenuPanelPosition.x + 'px',
      top: nodeMenuPanelPosition.y + 'px'
    }">
      {{ currentNode.text }}
    </div>
    <!-- 元素图谱 -->
    <RelationGraph ref="graphRef" :options="graphOptions" :on-node-click="onNodeClick"
      :on-node-collapse="toggleNodeCollapse" :on-node-expand="toggleNodeExpand"
      v-if="graphOptions && graphOptions.backgroundImage"
      :class="[`expand-status-${expandValue}`, `layoutType-${layoutType}`]" v-show="elementInit">
      <template #node="{ node }">
        <div class="custom-node"
          :style="{ width: node.width + 'px', height: node.height + 'px', borderRadius: node.width + 'px', background: node.color, }"
          @mouseover="showNodeTips(node, $event)" @mouseout="hideNodeTips(node, $event)" :data-color="node.color">
          <div class="custom-node-name"
            v-text="formattedText(node.text !== '思政元素体系' ? node.text.substr(0, 8) : node.text)">
          </div>
        </div>
      </template>
    </RelationGraph>
    <Footer></Footer>
  </div>
</template>

<script>
import RelationGraph from 'relation-graph'
import Header from './Header.vue'
import Footer from '../../components/Footer.vue'
import backgroundImage from "../../assets/image/elementGraph/page-background.png"
import services from '../../assets/js/services'
import { mapState, mapActions, mapMutations } from 'vuex'
import "swiper/dist/css/swiper.css";
import Swiper from 'swiper'
import axios from "axios";
import * as echarts from 'echarts';
import 'echarts-wordcloud'
export default {
  name: 'KnowledgeGraph',
  components: { RelationGraph, Header, Footer },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),// 院校code
      loading: false, // 加载状态
      pdfVisible: false, // 案例资源预览弹框显示状态
      alzyInfoId: "", // 当前预览的案例资源id
      pdfUrl: "", // 案例资源预览地址
      isShowNodeTipsPanel: false, // 是否显示节点提示框
      nodeMenuPanelPosition: { x: 0, y: 0 }, // 节点提示框的位置
      currentNode: null, // tooltip显示信息
      selectNode: null,// 选中的节点,
      expandValue: -1, // 弹框状态 -1|0|1 => 隐藏|默认|拉伸
      nhljModal: false, // 内涵理解详情弹窗是否显示
      nhljUrl: "", // 内涵理解详情url
      graphOptions: {},
      graphOptions1: { // 中心布局配置
        defaultZoom: 50,
        backgroundImage: backgroundImage,
        backgroundImageNoRepeat: true,
        defaultFocusRootNode: false, // 默认不选中根节点
        defaultNodeBorderWidth: 0, // 默认节点边框宽度（0表示无边框）
        defaultLineShape: 1,
        layouts: [
          {
            label: "中心",
            layoutName: "center",
            centerOffset_x: 0,
            centerOffset_y: 0,
            distance_coefficient: 1.4,
          }
        ],
      },
      graphOptions2: { // 树形布局配置
        backgroundImage: backgroundImage,
        backgroundImageNoRepeat: true,
        defaultFocusRootNode: false, // 默认不选中根节点
        defaultLineShape: 4,
        defaultJunctionPoint: "lr",
        direction: "left-right",
        layouts: [
          {
            label: "树形",
            layoutName: "tree",
            from: "left",
            min_per_height: 100, // 最小纵向间距
            max_per_height: 100, // 最大纵向间距
          }
        ]
      },
      subject_big_id: undefined, // 选中的专业大类
      subject_small_id: undefined,// 选中的专业小类
      subject_major_id: undefined,// 选中的专业
      keyword: "", // 思政元素关键词
      subjectBigData: [],//专业大类数据
      subjectSmallData: [],//专业小类数据
      subjectfilterData: [],//专业数据
      szyskData: [], // 思政元素库列表
      fitMajor: [], // 适用专业列表
      orginMajor: [], // 适用专业列表源数据
      szyszyData: [],// 思政元素资源列表
      szyszyTotal: 0, // 思政元素资源总条数
      alzyData: [], // 案例资源列表
      alzyTotal: 0, // 案例资源总条数
      connotation: "",// 内涵理解
      graphData: [], // 图谱数据
      allGraphData: [], // 全部图谱数据 用于查找父元素
      swiperOption: { // 轮播图配置项
        loop: true,
        loopFillGroupWithBlank: false,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 12,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      mySwiper: null, // 轮播图实例
      fitMajorImgs: ["one", "two", "three", "four", "five", "six"], // 5张背景图,用类名控制
      layoutType: 1, // 布局类型 1中心 2树形
      // 构建了专业能力图谱, 按照“学院/专业群”逻辑群显示
      filterData: [],
      major_id: "", // 思政元素图谱 - 选中的专业id
      major_keyword: "",// 思政元素图谱 - 选中的专业名称
      group_id: "", // 思政元素图谱 - 选中的学院业id
      detailContent: {
        id: "", // 专业id
        name: "", // 专业名称
        position: "",// 专业定位
        target: "", // 专业育人目标
        szys: [], // 适用的思政元素
        abstract: "", // 思政元素说明
      },
      cloudChart: null,
      showWordCloud: true,// 是否显示词云
      elementInit: false, // 路由参数存在且初始化完成再显示图谱
    }
  },
  computed: {
    ...mapState({
      downloadList: (state) => state.class.downloadIdList,
      appsUserInfo: state => state.appsLogin.appsUserInfo,
      schoolMenu: state => state.appsLogin.schoolMenu,
    }),
    // 是否开启能力图谱
    open_ability() {
      return this.schoolMenu?.open_ability
    },
    // 是否开启校本元素图谱
    open_element() {
      return this.schoolMenu?.open_element
    }
  },
  watch: {
    // 监听 open_ability 变化,确保有值后再执行
    open_ability: {
      immediate: true, // 立即执行一次
      handler(newVal) {
        if (newVal == 1 || newVal == 2) {
          this.initData()
        }
      }
    }
  },
  beforeDestroy() {
    this.cloudChart && this.cloudChart.dispose();
  },

  async mounted() {
    this.layoutType = this.$route.query.layoutType || 1
  },
  handleSzysMore() {

  },
  methods: {
    ...mapActions(["goAppsDetailsBeforeLogin", "schoolLoginRedirect", "getAppsImageCaptcha",]),
    ...mapMutations(["setDownloadIdList", "setAppsLoginVisible"]),
    initWordCloud() {
      this.cloudChart && this.cloudChart.dispose();
      const data = this.detailContent.szys.map(word => ({
        name: word,
        value: Math.round(Math.random() * 100) + 10
      }))

      const chartDom = this.$refs.cloudChart
      this.cloudChart = echarts.init(chartDom)

      const option = {
        tooltip: { show: false },
        series: [{
          type: 'wordCloud',
          shape: 'circle',
          left: 'center',
          top: 'center',
          width: '95%',
          height: '95%',
          sizeRange: [12, 22],
          rotationRange: [0, 90],
          gridSize: 5,
          drawOutOfBound: false,
          // textPadding: 2,
          shrinkToFit: true,
          textStyle: {
            fontWeight: 'bold',
            color() {
              const colors = ['#345A91', '#ABB2B4', '#F56D69', '#CD8230', '#E98452', '#4D8BFF', '#EEB741', '#ED9C75', '#5CCCFB', '#61AEF9', '#E1A57F']
              return colors[Math.floor(Math.random() * colors.length)]
            }
          },
          emphasis: {
            focus: 'none'
          },
          data
        }]
      }

      this.cloudChart.setOption(option)
    },
    // 初始化数据
    async initData() {
      let query = this.$route.query
      if (this.open_ability == 1) {
        this.group_id = query.group_id
        this.major_id = query.major_id
        await this.getGroupFilter()
      } else {
        await this.getSubjectBigData()
      }
      await this.showGraph()
      document.querySelectorAll(".c-mb-button[title=刷新]")[0].addEventListener("click", function () {
        setTimeout(function () {
          setTimeout(() => {
            const stopButton = document.querySelectorAll("div[title=点击停止自动布局]")[0]
            stopButton && stopButton.click()
            setTimeout(() => {
              const startButton = document.querySelectorAll("div[title=点击开始自动调整布局]")[0]
              startButton && startButton.click()
            }, 300)
          }, 200);
        }, 500)
      })

      await this.initFitMajorImg()

      await this.initQuery()


      if (this.open_ability == 1 && query.group_id && query.major_id) {
        await this.onNodeClick({ id: "m_" + query.major_id, })
        let graphInstance = await this.$refs.graphRef.getInstance()
        await graphInstance.focusNodeById("m_" + query.major_id);
      }
    },
    loginModal(val) {
      let that = this;
      // 如果需要统一登录,跳转
      let param = {
        format: "json",
        school_code: that.school_code,
        from: window.location.href,
      };
      that.schoolLoginRedirect(param).then(async (res) => {
        if (
          res.code == "0000" &&
          res.data &&
          !(res.data.redirect.indexOf(services.APPS_WEB) > -1)
        ) {
          return window.open(res.data.redirect, "_self");
        } else {
          await that.setAppsLoginVisible(val);
          if (val) {
            await that.getAppsImageCaptcha();
          }
        }
      });
    },
    handleSelect(item) {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id
      if (!isLoggedIn) return this.loginModal(true) // 未登录显示登录弹框 
      this.handleExpand(-1);
      this.group_id = item && item.pid
      this.major_id = item && item.id
      this.showGraph()
      this.detailContent = {}
      this.selectNode = null
      let graphInstance = this.$refs.graphRef.getInstance()
      graphInstance.focusNodeById(this.graphData[0] && this.graphData[0].id);
      // this.refreshLayout()
    },
    async getGroupFilter() {
      let res = await services.getGroupFilter({ school_code: this.school_code })
      if (res.code == '0000' && (res.data.group_list || res.data.major_list)) {
        this.filterData = this.transformData([...res.data.group_list, ...res.data.major_list])
        let query = this.$route.query
        if (!query.group_id || !query.major_id) {
          this.major_id = this.filterData[0].children[0].id
          this.group_id = this.filterData[0].id
        }

        // 初始化时计算所有内容高度
        this.$nextTick(() => {
          this.$refs.majorContents && this.$refs.majorContents.forEach((el, index) => {
            this.filterData[index].contentHeight = el.scrollHeight;
          });
        });
      }
    },

    // 数据转换
    transformData(data) {
      // 找出父级节点（pid为空的节点）
      const parentNodes = data.filter(item => !item.pid);

      // 找出子级节点（pid不为空的节点）
      const childNodes = data.filter(item => item.pid);

      // 转换父级节点为目标格式
      const result = parentNodes.map(parent => {
        // 找出该父级节点下的所有子节点
        const children = childNodes.filter(child => child.pid == parent.id)
          .map(child => ({
            id: child.id.toString(),
            name: child.name,
            pid: child.pid
          }));

        return {
          id: parent.id.toString(),
          name: parent.name,
          pid: parent.pid,
          children: children
        };
      });

      return result;
    },
    majorExpand(index) {
      this.$set(this.filterData, index, {
        ...this.filterData[index],
        expand: !this.filterData[index].expand
      });
    },
    toggleNodeCollapse() {
      this.refreshLayout()
    },
    toggleLayout(value) {
      if (this.layoutType != value) {
        this.$router.push({
          path: `/${this.school_code}/zy/elementGraph`,
          query: {
            ...this.$route.query,
            layoutType: value
          }
        })
        window.location.reload()
      }
    },
    // 文本每4个字换行
    formattedText(originalText) {
      if (this.layoutType == 2) return originalText
      if (originalText == '思政元素体系') return originalText
      let result = '';
      for (let i = 0; i < originalText.length; i++) {
        result += originalText[i];
        if ((i + 1) % 4 == 0 && i !== originalText.length - 1) {
          result += '\n';
        }
      }
      return result;
    },
    // 在methods中添加方法
    expandNodeById(nodeId) {
      let graphInstance = this.$refs.graphRef.getInstance()
      if (graphInstance) {
        const node = graphInstance.getNodeById(nodeId);
        if (node) {
          node.expanded = true;
        }
      }
    },
    // 路由参数自动选中
    async initQuery() {
      this.loading = true
      let that = this
      let id = this.$route.query.id
      let pid = this.$route.query.pid
      let element_id = this.$route.query.element_id && 'e_' + this.$route.query.element_id
      let element_first_name = this.$route.query.element_first_name

      if (!id && !element_id && !element_first_name) return this.elementInit = true
      let graphInstance = this.$refs.graphRef.getInstance()
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id
      if (isLoggedIn) {
        if (id) {
          id = "e_" + id
          graphInstance.focusNodeById(id);
          this.onNodeClick({ id, pid, }) // 如果登录了自动展开右侧信息
          setTimeout(function () {
            that.refreshLayout()
          }, 500)
        }
      } else if (!element_id) {
        this.loginModal(true) // 未登录显示登录弹框 
      }

      if (element_id && isLoggedIn) {
        this.loading = true
        try {
          let res = await services.getGroupElementCondition({ element_id: this.getId(element_id), school_code: this.school_code })
          if (res.code == '0000' && res.data.major_list) {
            this.filterData.forEach(item => {
              if (item.children && item.children.length > 0) {
                item.children.forEach(item => {
                  if (item.id == res.data.major_list.id) {
                    that.handleSelect(item)
                    setTimeout(async () => {
                      graphInstance.focusNodeById(element_id);
                      let parents = that.findParents(that.allGraphData, element_id)
                      if (parents && parents.length > 0) {
                        parents.forEach(item => {
                          that.expandNodeById(item.id)
                        })
                      }
                      setTimeout(function () {
                        that.elementInit = true
                        that.onNodeClick({ id: element_id }) // 如果登录了自动展开右侧信息
                        setTimeout(() => that.refreshLayout(), 0)
                        that.loading = false
                      }, 500)
                    }, 500)
                  }
                })
              } else {

              }
            })
          } else {
            that.elementInit = false
            that.loading = false
          }
        } catch {
          that.loading = false
          that.elementInit = true
        }
      } else {
        that.loading = false
        that.elementInit = true
      }

      if (element_first_name && isLoggedIn) {
        this.loading = true
        try {
          let filter = that.graphData.filter(item => item.name == element_first_name)
          if (filter && filter[0].id) {
            setTimeout(function () {
              graphInstance.focusNodeById(filter[0].id);
              that.onNodeClick({ id: filter[0].id, pid: filter[0].pid, }) // 如果登录了自动展开右侧信息
              setTimeout(function () {
                that.refreshLayout()
              }, 500)
            }, 1500)
          }
        } catch {
          that.loading = false
          that.elementInit = true
        }
      }
    },
    // 课程思政元素库更多
    szyszyMore() {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id
      if (isLoggedIn) {
        let params = {
          order_name: "new_visit_num",
        }
        let parents = this.findParents(this.allGraphData, this.selectNode.id)
        let level = 0
        parents.forEach(item => {
          level += 1
          if (item.id.startsWith("e_")) {
            if (this.open_ability == 1) {
              if (level == 2) {
                params.element_first_id = this.getId(item.id)
              } else if (level == 3) {
                params.element_second_id = this.getId(item.id)
              } else if (level == 4) {
                params.element_third_id = this.getId(item.id)
              } else if (level == 5) {
                params.element_fourth_id = this.getId(item.id)
              }
            } else {
              if (item.pid.startsWith("e_")) {
                params.element_second_id = this.getId(item.id)
              } else {
                params.element_first_id = this.getId(item.id)
              }
            }
          } else if (item.id.startsWith("b_")) {
            params.subjectbigid = this.getId(item.id)
          } else if (item.id.startsWith("s_")) {
            params.subjectsmallid = this.getId(item.id)
          } else if (item.id.startsWith("m_")) {
            params.major_id = this.getId(item.id)
          }
        })

        if (this.group_id) params.group_id = this.group_id
        if (this.major_id) params.major_id = this.major_id
        const targetRoute = this.$router.resolve({
          path: `/${this.school_code}/zy/szzyk`,
          query: params
        })

        window.open(targetRoute.href)
      } else {
        this.loginModal(true)
      }

    },

    // 根据id查找节点名称
    findName(id) {
      const filterArr = this.allGraphData && this.allGraphData.filter((item) => item.id == id)
      const name = (filterArr && filterArr.length > 0 && filterArr[0].name) || ""
      return name
    },
    // 内涵理解详情
    handleNhljDetail() {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id;
      if (isLoggedIn) {
        this.nhljUrl = `${window.location.origin}/${this.school_code}/zy/szysk/details?id=${this.getId(this.selectNode.id)}`
        this.nhljModal = true
      } else {
        this.loginModal(true)
      }
    },
    // 关闭内涵理解弹框,清空内容
    nhljCloseModal() {
      this.nhljUrl = ""
    },
    // 关闭案例资源弹框 清空信息
    pdfCloseMadol() {
      this.pdfVisible = false;
      this.pdfUrl = "";
      this.alzyInfoId = "";
      this.fileName = "";
    },
    // 获取案例资源详情、预览
    async getzyalInfo(id) {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id;
      if (isLoggedIn) {
        let res = await services.getalzyInfo(id);
        if (res.code == "0000") {
          this.pdfUrl = res.data.view_file;
          this.fileName = res.data.name;
          this.alzyInfoId = res.data.id;
          this.pdfVisible = true;
        }
      } else {
        this.loginModal(true)
      }
    },
    // 生成blob、下载案例资源
    createUrlBlob(url, fileName) {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.setAttribute("download", fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    // 案例资源下载
    downloadpdf() {
      this.setDownloadIdList(this.alzyInfoId);
      axios({
        url: services.HOST + "/api/school/cases/download",
        params: { id: this.alzyInfoId },
        method: "get",
        responseType: "arraybuffer",
      }).then((res) => {
        let newUrl = window.URL.createObjectURL(new Blob([res.data]));
        this.setDownloadIdList(this.alzyInfoId);
        this.createUrlBlob(
          newUrl,
          this.fileName + '.pdf'
        );
      });
    },
    // 路由跳转
    toAlzyDetail(path) {
      let query = {
        flag: 1,
        caseType: ""
      }
      // 确定过滤ID
      let filterId = "";
      const idMap = [
        { condition: this.subject_major_id, prefix: "m_" },
        { condition: this.subject_small_id, prefix: "s_" },
        { condition: this.subject_big_id, prefix: "b_" }
      ];

      const matchedId = idMap.find(item => item.condition);
      if (matchedId) {
        filterId = matchedId.prefix + matchedId.condition;
      }

      let parents = this.findParents(this.allGraphData, filterId)
      parents.forEach(item => {
        if (item.id.startsWith("b_")) {
          query.subjectBigId = this.getId(item.id)
        } else if (item.id.startsWith("s_")) {
          query.subjectSmallId = this.getId(item.id)
        }
      })

      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id
      if (isLoggedIn) {
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}${path}`,
          query: query
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.loginModal(true)
      }
    },

    // 初始化适用专业默认的背景图
    initFitMajorImg() {
      this.fitMajor.forEach((item, index) => {
        item.classname = this.fitMajorImgs[(index % 6)]
      });
    },
    // 初始化适用专业轮播图
    initSwiper() {
      let that = this
      that.mySwiper && that.mySwiper.initialized && that.mySwiper.destroy(true, true); // 彻底销毁旧实例
      that.$nextTick(() => {
        that.mySwiper = new Swiper(".swiper", that.swiperOption);
      });
    },

    // 弹框 展开/收起 value弹层状态 calculate是否计算
    handleExpand(value, calculate) {
      let that = this
      let scrollNode = document.getElementsByClassName("scroll")[0]
      if (scrollNode) scrollNode = 0
      function updateSwiper(perView, spaceBetween) {
        that.swiperOption.slidesPerView = perView
        that.swiperOption.slidesPerGroup = perView
        that.swiperOption.spaceBetween = spaceBetween
        that.$nextTick(() => {
          that.initSwiper()
        });
      }
      let oldVal = that.expandValue
      if (calculate) {
        that.expandValue += value
        if (value == 0) that.expandValue = 0
        if (value >= 1) that.expandValue = 1
        if (value < -1) that.expandValue = -1
      } else {
        that.expandValue = value
      }
      setTimeout(function () {
        if (oldVal != value) that.cloudChart && that.cloudChart.resize()
      }, 300)

      if (that.expandValue > 0) {
        setTimeout(function () {
          updateSwiper(5, 19)
        }, 1000)
      } else {
        setTimeout(function () {
          updateSwiper(3, 12)
        }, 1000)
      }

    },
    // 跳转到思政元素资源详情
    goSzyszyDetails(item) {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id;
      if (isLoggedIn) {
        let params = {
          id: item.id,
        };
        let routeUrl = this.$router.resolve({
          path: `/${this.school_code}/zy/szzyk/details`,
          query: params
        })
        window.open(routeUrl.href, "_blank");
      } else {
        this.loginModal(true)
      }
    },
    // 专业小类改变 => 获取专业数据
    async subjectSmallChange() {
      this.subject_major_id = undefined
      this.subjectfilterData = []
      if (this.subject_big_id && this.subject_small_id) {
        let params = {
          school_code: this.school_code,
          subject_big_id: this.subject_big_id,
          subject_small_id: this.subject_small_id
        }
        let defaultVal = {
          id: undefined,
          pid: params.subject_small_id, // 上级id
          name: "全部专业",
          type: "3", // 1大类 2小类 3专业
        }
        let result = await services.getGraphSubject(params)
        this.subjectfilterData = [defaultVal, ...result.data]
      }
    },
    // 专业大类改变 => 获取专业小类数据
    async subjectBigChange() {
      this.subject_small_id = undefined
      this.subject_major_id = undefined
      this.subjectSmallData = []
      this.subjectfilterData = []
      if (this.subject_big_id) {
        let params = {
          school_code: this.school_code,
          subject_big_id: this.subject_big_id
        }
        let defaultVal = {
          id: undefined,
          pid: params.subject_big_id, // 上级id
          name: "全部专业小类",
          type: "2", // 1大类 2小类 3专业
        }
        let result = await services.getGraphSubject(params)
        this.subjectSmallData = [defaultVal, ...result.data]

      }
    },
    // 获取专业大类数据
    async getSubjectBigData() {
      let params = {
        school_code: this.school_code,
        subject_big_id: this.subject_big_id
      }
      let defaultVal = {
        id: undefined,
        pid: "", // 上级id
        name: "全部专业大类",
        type: "1", // 1大类 2小类 3专业
      }
      let result = await services.getGraphSubject(params)
      this.subjectBigData = [defaultVal, ...result.data]
      this.fitMajor = result.data
      this.orginMajor = result.data
    },
    // 重置
    handleReset() {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id;
      const graphInstance = this.$refs.graphRef.getInstance();
      graphInstance.clearChecked();
      if (isLoggedIn) {
        this.handleExpand(-1)
        this.subject_big_id = undefined
        this.subject_small_id = undefined
        this.subject_major_id = undefined
        this.subjectSmallData = []
        this.subjectfilterData = []
        this.keyword = ""
        this.showGraph()
      } else {
        this.loginModal(true)
      }
    },
    // 筛选
    async handleFilter() {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id;
      // 检查登录状态
      if (!isLoggedIn) {
        await this.loginModal(true);
        return;
      }
      let filterId = ""; // 最终筛选ID
      // 图谱开放状态下的逻辑
      if (this.open_ability == 1) {
        // if (!this.major_keyword) {
        //   this.handleExpand(-1);
        //   this.group_id = item.pid
        //   this.major_id = item.id
        //   this.showGraph()
        //   this.detailContent = {}
        //   this.selectNode = null
        //   let graphInstance = this.$refs.graphRef.getInstance()
        //   graphInstance.focusNodeById(this.graphData[0] && this.graphData[0].id);
        //   this.refreshLayout()
        // }
        await this.showGraph();
        if (this.graphData && this.graphData.length > 1) {
          filterId = this.graphData[1].id
        }
      }
      // 普通状态下的逻辑
      else {
        const idMap = [
          { condition: this.subject_major_id, prefix: "m_" },
          { condition: this.subject_small_id, prefix: "s_" },
          { condition: this.subject_big_id, prefix: "b_" },
        ];
        const matchedId = idMap.find(item => item.condition);
        if (matchedId) filterId = matchedId.prefix + matchedId.condition;

        await this.showGraph(filterId);
      }


      if (this.open_ability == 1 && !this.major_keyword) return
      // 公共选中逻辑
      await this.$nextTick(async () => {
        if (filterId) {
          const graph = this.$refs.graphRef?.getInstance?.();
          if (graph) {
            graph.focusNodeById(filterId);
            await this.onNodeClick({ id: filterId });
            await this.refreshLayout();
          }
        } else {
          this.handleExpand(-1);
        }
      });
    },

    // 切换节点展开状态：登录后才能展开点击二级节点展开三级
    toggleNodeExpand(node) {
      const isRootNode = this.findParents(this.allGraphData, node.id).length == 1;
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id;
      if (isRootNode) {
        this.refreshLayout()
      } else if (isLoggedIn) {
        this.refreshLayout()

      } else {
        node.expanded = false;
        this.loginModal(true);
      }

    },
    // 节点样式统一管理：颜色、尺寸、边框
    getNodeStyle(level, node, graphData) {
      // 每个层级的节点尺寸
      const sizes = [180, 150, 140, 130, 120, 110]

      // 每个层级的连线颜色
      const borderColors = ["", "#4CB0F3", "#A0AAFD", "#30CAE5", "#F3A873", "#4DC6F3"]

      // 根节点固定颜色
      const rootColor = '#62666d'

      // 分支颜色池
      const branchColors = [
        // 原设计色 + 扩展自定义色
        'linear-gradient(0deg, #F87E62 0%, #F3A873 100%)',
        'linear-gradient(0deg, #349AB3 0%, #8CE1F5 100%)',
        'linear-gradient(0deg, #C776D3 0%, #F4B3C9 100%)',
        'linear-gradient(0deg, #12B8D6 0%, #12D6D1 100%)',
        'linear-gradient(0deg, #F2AE37 0%, #F2E068 100%)',
        'linear-gradient(0deg, #F466A5 0%, #FB8D82 100%)',
        'linear-gradient(0deg, #50BE9E 0%, #82CBA1 100%)',
        'linear-gradient(0deg, #46A6FF 0%, #4DC6F3 100%)',
        'linear-gradient(0deg, #A0AAFD 0%, #5B79D7 100%)',
        'linear-gradient(0deg, #3887E3 0%, #4CB0F3 100%)',

        // 新增扩展色
        'linear-gradient(0deg, #FF9E7A 0%, #FFD29A 100%)',
        'linear-gradient(0deg, #72C5A8 0%, #A6E3BE 100%)',
        'linear-gradient(0deg, #FF93B8 0%, #F8C7DA 100%)',
        'linear-gradient(0deg, #7AA9FF 0%, #A9C8FF 100%)',
        'linear-gradient(0deg, #CBA1FF 0%, #E1C4FF 100%)',
        'linear-gradient(0deg, #FFA67C 0%, #FFD9B5 100%)',
        'linear-gradient(0deg, #47D2A8 0%, #7EE7C3 100%)',
        'linear-gradient(0deg, #8EC5FC 0%, #E0C3FC 100%)',
        'linear-gradient(0deg, #FFD580 0%, #FFB64E 100%)',
        'linear-gradient(0deg, #FF7E79 0%, #FFB3A0 100%)'
      ]



      // 每个等级的颜色
      const openElementColors = [
        'linear-gradient(0deg, #F87A75 0%, #E6473E 100%)', // 层级1
        'linear-gradient(0deg, #A0AAFD 0%, #5B79D7 100%)', // 层级2
        'linear-gradient(0deg, #68BDFD 0%, #3EA8F9 100%)', // 层级3
        'linear-gradient(0deg, #FB8D82 0%, #F37F5F 100%)',  // 层级4
        'linear-gradient(0deg, #81E8D0 0%, #56CCAE 100%)',  // 层级5
      ]

      // 缓存：每支分支对应颜色
      if (!this._branchColorMap) this._branchColorMap = {}

      // 如果是根节点
      if (!node.pid || node.pid == '0') {
        this._branchColorMap = {} // 每次重新计算清空
        if (this.open_element == 2) {
          return {
            color: openElementColors[level - 1],
            size: sizes[level - 1] || 120,
            borderColor: borderColors[level - 1] || '#ccc'
          }
        } else {
          return {
            color: rootColor,
            size: sizes[level - 1] || 120,
            borderColor: borderColors[level - 1] || '#ccc'
          }
        }

      }

      // 找到根节点（pid为0）
      const root = graphData.find(n => !n.pid || n.pid == '0')

      // 找出该节点所属一级分支（即：它的第一个父节点）
      const findRootBranch = (id) => {
        const parent = graphData.find(n => n.id == id)
        if (!parent) return null
        if (parent.pid == root?.id) return parent.id
        return findRootBranch(parent.pid)
      }

      const branchRootId = findRootBranch(node.id)
      if (branchRootId) {
        // 如果该分支未分配颜色,则分配一个
        if (!this._branchColorMap[branchRootId]) {
          const index = Object.keys(this._branchColorMap).length
          this._branchColorMap[branchRootId] = branchColors[index % branchColors.length]
        }
      }

      const color = this._branchColorMap[branchRootId] || branchColors[0]
      const size = sizes[level - 1] || 120
      const borderColor = borderColors[level - 1] || '#ccc'

      if (this.open_element == 2) {
        return {
          color: openElementColors[level - 1],
          size: sizes[level - 1] || 120,
          borderColor: borderColors[level - 1] || '#ccc'
        }
      } else {
        return { color, size, borderColor }
      }
    },
    // 显示tooltip
    showNodeTips(nodeObject, $event) {
      this.currentNode = nodeObject;
      const position = this.$refs.graphContainer.getBoundingClientRect();
      this.isShowNodeTipsPanel = true;
      this.nodeMenuPanelPosition.x = $event.clientX - position.x + 10;
      this.nodeMenuPanelPosition.y = $event.clientY - position.y + 10;
    },
    // 隐藏tooltip
    hideNodeTips() {
      this.isShowNodeTipsPanel = false;
    },
    // 计算等级
    calculateNodeLevel(nodes, nodeId, currentLevel = 0) {
      const node = nodes.find((n) => n.id == nodeId)
      if (!node || !node.pid) return currentLevel
      return this.calculateNodeLevel(nodes, node.pid, currentLevel + 1)
    },
    // 构建图谱节点与连线数据
    buildGraphData(graphData, filterId) {
      if (!Array.isArray(graphData) || graphData.length == 0) {
        return { nodes: [], lines: [] }
      }

      // 提前缓存 filterId 的父链
      const filterParents = filterId ? this.findParents(graphData, filterId) : []

      // 节点构建
      const nodes = graphData.map((item, index) => {
        const hasChildren = graphData.some(n => n.pid == item.id)
        const parents = this.findParents(graphData, item.id)
        const level = this.calculateNodeLevel(graphData, item.id)

        // 节点展开逻辑
        // const shouldExpand = filterId
        //   ? filterParents.some(p => p.id == item.id) // 筛选时仅展开目标父链
        //   : hasChildren && parents.length < 2   // 默认展开前两级

        const shouldExpand = this.open_element == 1 ? level <= 2 : (filterId ? filterParents.some(p => p.id == item.id) : hasChildren && parents.length < 2)

        // const shouldExpand = level <= 2
        // 计算层级样式（颜色、大小、边框）
        const { color: styleColor, size, borderColor } = this.getNodeStyle(level, item, graphData)

        // 颜色逻辑：只有配置了 item.color 才使用，否则用前端计算的颜色
        // 不继承父节点颜色，配置的颜色是单独隔离的
        const finalColor = item.color || styleColor

        // 构建节点对象
        const node = {
          id: item.id,
          text: item.name,
          level,
          expanded: shouldExpand,
          expandHolderPosition: hasChildren ? 'top' : undefined,
          color: finalColor,
          width: size,
          height: size,
          borderRadius: size / 2
        }

        // 记录边框颜色用于连线
        graphData[index].borderColor = borderColor
        return node
      })

      // 连线构建
      const lines = graphData
        .filter(item => item.pid && item.pid !== "0")
        .map(item => ({
          from: item.pid,
          to: item.id,
          color: item.borderColor,
          lineWidth: 3,
        }))

      // 根节点
      const rootNode = nodes.find(node => {
        const raw = graphData.find(n => n.id == node.id)
        return !raw?.pid
      })

      // 返回结果
      return {
        rootId: rootNode?.id || nodes[0]?.id || 'root',
        nodes,
        lines,
      }
    },
    // 找到专业大类ID
    getSubjectBigId(nodeId, nodeList) {
      // 如果当前节点就是大类节点
      if (nodeId.startsWith("b_")) {
        return nodeId;
      }

      // 查找当前节点
      const currentNode = nodeList.find(node => node.id == nodeId);
      if (!currentNode) return null;

      // 递归查找大类节点
      function findBigId(node) {
        if (node.id.startsWith("b_")) {
          return node.id;
        }
        if (node.pid == "0") return null; // 防止无限循环

        const parentNode = nodeList.find(n => n.id == node.pid);
        return parentNode ? findBigId(parentNode) : null;
      }

      return findBigId(currentNode);
    },
    // 节点点击事件
    async onNodeClick(node) {
      const isLoggedIn = this.appsUserInfo && this.appsUserInfo.id
      if (!isLoggedIn) return this.loginModal(true) // 未登录显示登录弹框 
      // 没有节点ID直接返回
      if (!node?.id) {
        this.selectNode = null;
        return;
      }
      // if (node.id.startsWith("m_")) return
      // 初始化状态
      this.showWordCloud = false;
      this.detailContent = {
        id: "",
        name: "",
        position: "",
        target: "",
        szys: [],
        abstract: ""
      };


      // 处理拖拽状态
      if (this.selectNode && this.selectNode.disableDrag) {
        this.selectNode.disableDrag = false;
      }
      node.disableDrag = true;
      this.selectNode = node;

      // 处理图谱展开逻辑
      await this.handleExpand(0);

      // 进入加载状态
      this.loading = true;

      // open_ability == 2
      if (this.open_ability == 2 || node.id.startsWith("m_")) {
        if (node.id.startsWith("e_")) {
          // 思政元素节点
          await this.requestSzyszy(node.id, "1"); // 相关思政元素
          this.fitMajor = this.orginMajor;
          await this.requestNhlj(this.getId(node.id)); // 内涵理解
          this.alzyData = [];
          this.alzyTotal = 0;
        } else if (["b_", "s_", "m_"].some(prefix => node.id.startsWith(prefix))) {
          // 专业节点
          this.open_ability == 1 ? await this.requestGroupResource() : await this.requestSzyszy(node.id, "2"); // 相关思政元素
          this.connotation = "";
          this.fitMajor = [];
          await this.getalzyList(); // 案例资源
        }

        this.loading = false;

        // 初始化轮播
        await this.$nextTick(() => this.initSwiper());
        return;
      }


      await this.requestGroupResource();
      this.fitMajor = this.orginMajor;
      await this.requestNhlj(this.getId(node.id));
      this.alzyData = [];
      this.alzyTotal = 0;
      this.loading = false;
    },
    // 获取专业能力图谱 思政元素相关资源
    async requestGroupResource() {
      let params = {
        school_code: this.school_code,
        open_element: this.open_element,
        order_name: "new_visit_num",
        favorite_flag: "1",
        lib_type: "0",
        page: 1,
        length: 10,
        group_id: this.group_id,
        major_id: this.major_id,
        knowledge: "",
        topic_id: ""
      }
      let parents = this.findParents(this.allGraphData, this.selectNode.id)
      parents.forEach(item => {
        if (item.id.startsWith("e_")) {
          let element_parents = this.findParents(this.allGraphData, item.id)
          element_parents.forEach(item => {
            let id = item.id
            if (id.startsWith("g_0")) return

            if (id.startsWith("e_")) {
              if (item.pid.startsWith("e_")) {
                params.element_second_id = this.getId(id)
              } else {
                params.element_first_id = this.getId(id)
              }
            }
          })
        }
      })

      // 获取数据
      let result = await services.getGroupResourceList(params)
      if (result.code == '0000' && result.data) {
        this.szyszyData = result.data.items
      }

      // 获取总条数
      let result2 = await services.getGroupResourceList({ ...params, count: 1 })
      if (result2.code == '0000' && result2.data) {
        this.szyszyTotal = result2.data.total
      }

    },
    // 案例资源
    async getalzyList() {
      let params = {
        school_code: this.school_code,
      }
      if (this.open_ability == 2) {
        params.subject_big_id = this.subject_big_id,
          params.subject_small_id = this.subject_small_id
      } else {
        params.group_id = this.group_id
        params.major_id = this.major_id
        params.open_ability = this.open_ability
      }
      let result = await services.getalzyList(params)
      this.alzyData = result.data.items
      this.alzyTotal = result.data.total
    },

    // 获取思政元素详情 (内涵理解)
    async requestNhlj(id) {
      let params = {
        id: id,
        open_element: this.open_element,
        school_code: this.school_code
      }
      // if (this.open_element == 1) {
      // params['open_element'] = this.open_element
      // params['school_code'] = this.school_code
      // }

      let result = await services.getSzyskDetails(params)
      if (result && result.code == "0000") {
        this.connotation = result.data.connotation
        if (this.open_element == 1) {
          this.detailContent['abstract'] = result.data.abstract
          this.detailContent['name'] = result.data.name
        }
      } else {
        this.connotation = ""
        this.detailContent['abstract'] = ""
      }
    },

    findParents(data, id) {
      const result = [];
      let currentId = id;

      // 递归查找父级
      while (currentId !== '0') {
        const currentNode = data.find(item => item.id == currentId);
        if (!currentNode) break; // 如果找不到节点,退出循环
        result.unshift(currentNode); // 将父级插入到数组开头
        currentId = currentNode.pid;
      }

      // 区分层级
      return result.map((item, index) => {
        let level;
        level = index + 1
        return { ...item, level };
      });
    },

    // 截取真实id
    getId(id) {
      return id.split("_")[1]
    },
    // 获取思政元素资源列表
    async requestSzyszy(id, type) {
      let params = {
        school_code: this.school_code,
        order_name: "new_visit_num",
        favorite_flag: "1",
        page: 1,
        length: 10
      }
      let parents = this.findParents(this.allGraphData, this.selectNode.id)
      parents.forEach(item => {
        if (item.id.startsWith("e_")) {
          let element_parents = this.findParents(this.allGraphData, item.id)
          element_parents.forEach(item => {
            let id = item.id
            if (id.startsWith("g_0")) return

            if (id.startsWith("e_")) {
              if (item.pid.startsWith("e_")) {
                params.element_second_id = this.getId(id)
              } else {
                params.element_first_id = this.getId(id)
              }
            }
          })
        } else if (item.id.startsWith("b_")) {
          params.subject_big_id = this.getId(item.id)
        } else if (item.id.startsWith("s_")) {
          params.subject_small_id = this.getId(item.id)
        } else if (item.id.startsWith("m_")) {
          if (this.open_element == 1) {
            params.major_id = this.getId(item.id)
          } else {
            params.subject_major_id = this.getId(item.id)
          }
        }
      })

      // 获取数据
      let result = await services.getSzzykListData(params)
      this.szyszyData = result.data.items

      // 获取总条数
      let result2 = await services.getSzzykListData({ ...params, count: 1 })
      this.szyszyTotal = result2.data.total
    },

    // 初始化图谱
    async showGraph(filterId) {
      let that = this
      let layoutType = this.$route.query.layoutType || 1
      this.graphOptions = this[`graphOptions${layoutType}`]

      // try {
      that.loading = true
      // 如果开启了能力图谱,按照学院/专业群逻辑显示
      if (this.open_ability == 1) {
        let params = {
          school_code: this.school_code,
          open_element: this.open_element,
          group_id: this.group_id,
          major_id: this.major_id,
          keyword: this.major_keyword
        }
        const result = await services.getGroupElement(params)
        that.graphData = result.data
        that.allGraphData = result.data

        if (that.graphData && that.graphData.length <= 1) {
          that.loading = false
          this.$message.info("暂无相关的思政元素")
        }
        const buildData = that.buildGraphData(that.graphData, filterId)
        that.$refs.graphRef.setJsonData(buildData, (graphInstance) => {
          setTimeout(function () {
            that.refreshLayout()
            setTimeout(function () {
              graphInstance.setZoom(60);// 缩放图谱到百分之多少
              that.loading = false
            }, 2000)
          }, 500)
        })

      } else {
        // 未开通显示系统默认形式
        let params = {
          school_code: that.school_code,
          subject_big_id: that.subject_big_id,
          subject_small_id: that.subject_small_id,
          subject_major_id: that.subject_major_id,
          keyword: that.keyword,
          shape: layoutType,
          open_element: that.open_element
        }
        params.shape = layoutType
        const result = await services.getGraphData(params)
        // if (layoutType == 1 || that.allGraphData.length == 0) {
        // 再次获取全部数据,全部数据用于查找父元素
        const allResult = await services.getGraphData({ ...params, shape: 2 })
        that.allGraphData = allResult.data
        // }
        that.graphData = result.data
        if (that.graphData && that.graphData.length <= 1) {
          that.loading = false
          this.$message.info("暂无相关的思政元素")
        }
        const buildData = that.buildGraphData(that.graphData, filterId)
        that.$refs.graphRef.setJsonData(buildData, (graphInstance) => {
          setTimeout(function () {
            that.refreshLayout()
            setTimeout(function () {
              graphInstance.setZoom(60);// 缩放图谱到百分之多少
              that.loading = false
            }, 2000)
          }, 500)
        })

      }
      that.loading = false
      // } catch (error) {
      //   // console.error('图谱初始化失败:', error)
      //   this.$message.info("暂无相关的思政元素")
      //   that.loading = false
      // }
    },

    // 重新布局
    refreshLayout() {
      // if (this.layoutType == 2) return
      const graphInstance = this.$refs.graphRef.getInstance()
      const refreshButton = document.querySelectorAll("div[title=刷新]")[0]
      refreshButton && refreshButton.click()
      setTimeout(() => {
        const stopButton = document.querySelectorAll("div[title=点击停止自动布局]")[0]
        stopButton && stopButton.click()
        setTimeout(() => {
          const startButton = document.querySelectorAll("div[title=点击开始自动调整布局]")[0]
          startButton && startButton.click()
          graphInstance.setZoom(60);// 缩放图谱到百分之多少
        }, 300)
      }, 200);
    },

  }
}
</script>

<style lang="less" scoped>
.relation-graph-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;

  &:has(.login) .rel-node-peel {
    box-shadow: none;
  }

  .spin-fixed {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1002;
  }

  .custom-node {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .custom-node-name {
      color: white;
      font-size: 24px;
      font-weight: bold;
      line-height: 1.2;
      text-align: center;
      word-break: keep-all;
      white-space: break-spaces;
      padding: 5px;
    }
  }

  .node-tooltip {
    z-index: 1000;
    padding: 10px;
    background-color: #ffffff;
    border: #eeeeee solid 1px;
    box-shadow: 0px 0px 8px #cccccc;
    position: absolute;
    font-size: 14px;
    color: #888888;
    border-radius: 0;
  }

  /deep/ .relation-graph {
    transition: all 0.3s;
    top: -3%;

    &.expand-status--1 {
      left: 0;
    }

    &.expand-status-0 {
      left: -100px;

      &.layoutType-2 {
        left: -300px;
      }
    }

    &.expand-status-1 {
      left: -450px;
    }

    &.noActive .rel-node-checked {
      border: none !important;
      box-shadow: none !important;
    }

    .rel-map {
      background-color: transparent;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .custom-node {
      box-shadow: none;
    }

    .rel-node-checked {
      box-shadow: 0 0 0 8px #dd363a !important;
      // border: 1px solid #fff !important;
    }

    .c-btn-open-close {
      z-index: 1000;
      top: 15%;
      left: 50%;
      transform: translateX(-50%);
      margin: 0;
    }

    .c-btn-open-close span {
      width: 24px;
      height: 24px;
    }

    .c-btn-open-close .c-collapsed {
      background: url('../../assets/image/elementGraph/graph-put.png') no-repeat center/cover;
    }

    .c-btn-open-close .c-expanded {
      background: url('../../assets/image/elementGraph/graph-expand.png') no-repeat center/cover;
    }

    // 根节点去掉部分交互
    // .rel-node-peel:first-child,
    .rel-node-peel[data-id='g_0'] {
      pointer-events: none;

      .c-btn-open-close {
        pointer-events: all;
      }
    }

    .c-expand-positon-top {
      width: auto;
      height: auto;
    }

    &.layoutType-2 {
      .rel-node-peel:has(.c-btn-open-close) .custom-node {
        padding: 8px 50px 8px 18px !important;
      }

      .rel-node-checked {
        box-shadow: 0 0 0 4px #dd363a !important;
        border: 1px solid #fff !important;
      }

      .rel-node {
        width: auto !important;
        height: auto !important;
      }

      .custom-node {
        width: auto !important;
        height: auto !important;
        border-radius: 5px !important;
        justify-content: flex-start;
        padding: 8px 18px !important;

        .custom-node-name {
          white-space: nowrap;
        }
      }

      .c-btn-open-close {
        left: auto !important;
        right: 24px !important;
        top: 50% !important;
        transform: translateY(-50%) !important;

        span {
          width: 18px;
          height: 18px;
        }
      }
    }
  }

  .graph-filter {
    position: fixed;
    top: 130px;
    left: 18px;
    z-index: 1000;
    padding: 34px 18px 38px;
    background: #fff;
    width: 250px;
    border: 1px solid #eae8e8;
    box-shadow: 0px 4px 10px 0px rgba(125, 126, 130, 0.22);

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      width: 100%;
      height: 4px;
      background: #dd353a;
      top: 0;
      left: 0;
    }

    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      bottom: 100%;
      width: 82px;
      height: 47px;
      background: url('../../assets/image/elementGraph/filter-header.png') no-repeat center/cover;
      left: 50%;
      transform: translateX(-50%);
    }

    /deep/ .filter-item {
      &>div {
        width: 100%;
        height: initial;
      }

      &:not(:last-child) {
        margin-bottom: 14px;
      }

      .ant-select-open {
        .ant-select-arrow {
          background: url('../../assets/image/elementGraph/select-arrow-active.png') no-repeat center/cover;
        }
      }

      .ant-select-selection__rendered {
        line-height: 40px;
      }

      .ant-select-selection__placeholder {
        color: #484848;
      }

      .ant-input::placeholder {
        color: #b2b2b2;
      }

      .ant-select-selection,
      .ant-input {
        height: 40px;
        background: #ffffff;
        border: 1px solid #ededed;
        border-radius: 0;
        outline: none;
        box-shadow: none;
        font-size: 14px;
        color: #484848;

        &:focus,
        &:active {
          border: 1px solid #ededed;
        }
      }

      .ant-input {
        height: 45px;
        line-height: 45px;
      }

      .ant-select-arrow {
        width: 9px;
        height: 9px;
        background: url('../../assets/image/elementGraph/select-arrow.png') no-repeat center/cover;

        * {
          display: none;
        }
      }

      &.active {
        .ant-select-selection {
          background: #fff5f5;
        }

        .ant-select-selection-selected-value {
          color: #dd363a;
        }

        .ant-select-arrow {
          background: url('../../assets/image/elementGraph/select-arrow-active.png') no-repeat center/cover;
        }
      }
    }

    .handle-group {
      display: flex;

      .handle-item {
        height: 40px;
        line-height: 40px;
        flex: 1;
        font-size: 14px;
        text-align: center;

        &:first-child {
          background: #f6f8f9;
          border-radius: 17px 0px 0px 17px;
          border: 1px solid #ededed;
          color: #5d5d5d;

          &:hover {
            background: #e0e3e8;
          }
        }

        cursor: pointer;
        background: #dd363a;
        border-radius: 0px 17px 17px 0px;
        color: #ffffff;

        &:hover {
          background: #e60e0f;
        }
      }
    }
  }

  .major-graph {
    position: fixed;
    left: 0;
    top: 48px;
    width: 235px;
    height: calc(100vh - 48px - 40px);
    background: #ffffff;
    box-shadow: 0px 4px 10px 0px rgba(125, 126, 130, 0.22);
    border: 1px solid #eae8e8;
    z-index: 1000;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 24px 16px 0;

    .major-filter {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;

      input {
        height: 100%;
        background: #ffffff;
        border: 1px solid #ededed;
        outline: none;
        border-radius: 0;
        padding: 0 14px;
        width: 140px;
      }

      .filter-button {
        width: 56px;
        height: 40px;
        background: #dd363a;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        flex-shrink: 0;
      }
    }

    .major-list {
      .school-item {
        border-bottom: 1px solid #dadfe2;
        padding: 12px 0 12px;

        .school-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          padding: 6px 0;
          cursor: pointer;

          .header-name {
            font-weight: bold;
            font-size: 15px;
            color: #2b2b2b;
            display: flex;

            &::before {
              content: '';
              display: inline-block;
              width: 14px;
              height: 17px;
              background: url('../../assets/image//elementGraph/school-label.png') no-repeat center/cover;
              flex-shrink: 0;
              margin: 3px 10px 0 0;
            }
          }

          .header-expand {
            width: 9px;
            height: 9px;
            background: url('../../assets/image/elementGraph/expand-down.png');
            margin-top: 7px;
            flex-shrink: 0;
          }
        }

        &.up .school-header .header-expand {
          background: url('../../assets/image/elementGraph/expand-up.png');
        }

        .school-major {
          overflow: hidden;
          transition: all 0.3s ease;

          .major-item {
            width: 100%;
            font-size: 14px;
            color: #666666;
            background: transparent;
            cursor: pointer;
            padding: 7.5px 24px;

            &.active,
            &:hover {
              background: #fff5f5;
              color: #dd363a;
            }
          }
        }
      }
    }
  }

  &.showAbility {
    /deep/ .relation-graph .rel-toolbar {
      left: 286px;
    }

    .toggle-layout {
      left: 593px;
    }

    // 根节点去掉部分交互
    // /deep/ .rel-node-peel:first-child {
    //     pointer-events: none;
    //     .c-btn-open-close {
    //         pointer-events: all;
    //     }
    // }
  }
}

.ant-select-dropdown {
  border-radius: 0;
}

/deep/.footer-box {
  width: 100%;
  position: fixed !important;
  left: 0;
  bottom: 0;
  z-index: 1000;
  background: #e0e3e8;

  .flex-box {
    display: none;
  }

  .copyright {
    color: #aeaeae;

    span,
    a {
      font-size: 10px;
      color: #aeaeae;
    }
  }
}

.grap-details-expand {
  width: 64px;
  height: 32px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #dcdcdd;
  color: #b1abac;
  cursor: pointer;
  position: fixed;
  top: 78px;
  right: 27px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    display: inline-block;
    width: 11px;
    height: 10px;
    background: url('../../assets/image/elementGraph/button-expand.png');
    margin-right: 7px;
  }

  &:hover {
    color: #dd363a;

    &::before {
      background: url('../../assets/image/elementGraph/button-expand-active.png');
    }
  }
}

.grap-details {
  position: fixed;
  height: calc(100vh - 48px - 40px);
  top: 48px;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(125, 126, 130, 0.22);
  border-radius: 0px 0px 0px 4px;
  border: 1px solid #eae8e8;
  transition: width 0.3s;
  display: flex;
  flex-direction: column;

  &.expand-status--1 {
    width: 0;
    white-space: nowrap;

    .put {
      opacity: 0;
      pointer-events: none;
    }
  }

  &.expand-status-0 {
    width: 440px;
    opacity: 1;
  }

  &.expand-status-1 {
    opacity: 1;
    width: 803px;

    .expand {
      opacity: 0;
      pointer-events: none;
    }

    .detail-name {

      &::before,
      &::after {
        display: inline-block !important;
      }
    }
  }

  &::before {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: linear-gradient(0deg, #ffffff 36%, #ffeaec 100%);
    border-radius: 0px 0px 0px 4px;
  }

  &>div {
    position: relative;
    z-index: 1;
  }

  .detail-header {
    display: flex;
    justify-content: space-between;
    padding: 15px 20px 0;

    .button-item {
      margin-top: 3px;
      font-size: 12px;
      color: #b1abac;
      cursor: pointer;
      white-space: nowrap;

      &::before,
      &::after {
        content: '';
        display: inline-block;
        width: 11px;
        height: 10px;
      }

      &:hover {
        color: #dd363a;
      }

      &.expand {
        &::before {
          background: url('../../assets/image/elementGraph/button-expand.png') no-repeat center/cover;
          margin-right: 7px;
        }

        &:hover::before {
          background: url('../../assets/image/elementGraph/button-expand-active.png') no-repeat center/cover;
        }
      }

      &.put {
        &::after {
          background: url('../../assets/image/elementGraph/button-put.png') no-repeat center/cover;
          margin-left: 7px;
        }

        &:hover::after {
          background: url('../../assets/image/elementGraph/button-put-active.png') no-repeat center/cover;
        }
      }
    }

    .detail-name {
      font-weight: bold;
      font-size: 17px;
      color: #ab0004;
      letter-spacing: 5px;
      text-align: center;
      position: relative;

      &::before,
      &::after {
        content: '';
        width: 77px;
        height: 17px;
        vertical-align: -3px;
        display: none;
      }

      &::before {
        background: url('../../assets/image/elementGraph/large-left.png') no-repeat center/cover;
        margin-right: 50px;
      }

      &::after {
        background: url('../../assets/image/elementGraph/large-right.png') no-repeat center/cover;
        margin-left: 50px;
      }
    }
  }

  .detail-content {
    flex: 1;
    overflow: hidden;
    padding: 18px 10px 0 20px;

    .scroll {
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding-right: 5px;
      padding-bottom: 21px;

      &::-webkit-scrollbar-track-piece {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.5);
        border-radius: 10px;
      }
    }

    .block-header {
      width: 100%;
      height: 30px;
      background: #fdf1ec;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 13px 0 9px;

      .block-left {
        display: flex;
        align-items: center;

        &::before {
          content: '';
          display: inline-block;
          width: 14px;
          height: 14px;
          background: url('../../assets/image/elementGraph/icon-nhlj.png');
          margin-right: 9px;
        }

        .block-name {
          font-weight: bold;
          font-size: 15px;
          color: #543129;
        }

        .block-num {
          font-size: 12px;
          color: #b8262a;
          margin-left: 11px;
        }
      }

      .block-button {
        font-size: 14px;
        color: #b60e0f;
        cursor: pointer;
      }
    }

    .connotation-box {
      .block-content {
        margin-top: 8px;
        width: 100%;
        background: #f7f8fd;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        padding: 13px 18px;
        white-space: pre-wrap;

        p {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }

        &:has(.wordCloud) {
          background: transparent;
          padding: 0;
        }

        .wordCloud {
          width: 100%;
          height: 300px;
        }
      }
    }

    .szyszy-box {
      margin-top: 18px;

      &+.item-text {
        margin-top: 18px;
      }

      .block-header {
        .block-left::before {
          background: url('../../assets/image/elementGraph/icon-szyszy.png') no-repeat center/cover;
        }
      }

      .block-content {
        .res-item {
          display: block;
          position: relative;

          /deep/ &>div:last-child:not(.res-info) {
            top: 40px !important;
            left: 3px !important;
            pointer-events: none;
          }

          padding: 18px 0 18px 33px;
          cursor: pointer;

          &:not(:last-child) {
            border-bottom: 1px solid #e9eaee;
          }

          /deep/ .ant-tooltip {
            top: 0 !important;
            left: 0 !important;
          }

          &:hover {
            background: linear-gradient(0deg,
                #ffffff 0%,
                #f3f3f3 100%);

            .res-info .res-title {
              color: #cf0d04;
            }
          }

          &.word .res-info::before {
            background: url('../../assets/image/home/word.png') no-repeat center;
            background-size: 100% auto;
          }

          &.video .res-info::before {
            background: url('../../assets/image/home/MP4.png') no-repeat center;
            background-size: 100% auto;
          }

          .res-info {
            display: flex;
            align-items: center;
            position: relative;

            &::before {
              content: '';
              display: inline-block;
              width: 13px;
              height: 12px;
              position: absolute;
              top: 5px;
              left: -21px;
            }

            .res-title {
              font-weight: bold;
              font-size: 14px;
              color: #333333;
              flex: 1;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .res-type {
              width: 64px;
              height: 20px;
              text-align: center;
              background: url('../../assets/image/szzyk/school-badge.png') no-repeat center/cover;
              margin-left: 15px;
            }
          }

          .res-suggest {
            font-size: 12px;
            color: #ad7b6d;
            margin-top: 3px;

            i {
              font-style: normal;
            }
          }
        }
      }
    }

    .syzy-box {
      margin-top: 25px;

      .block-header {
        .block-left::before {
          background: url('../../assets/image/elementGraph/icon-syzy.png') no-repeat center/cover;
        }

        /deep/ .swiper-handle {
          display: flex;
          align-items: center;

          .swiper-pagination {
            display: flex;
            align-items: center;
            position: unset !important;
            margin: 0 20px;
          }

          .swiper-button-prev,
          .swiper-button-next {
            width: 18px;
            height: 18px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #e5e5e5;
            position: relative !important;
            cursor: pointer;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: 0;

            &::before {
              content: '';
              display: inline-block;
              position: absolute;
              width: 7px;
              height: 8px;
              top: 50%;
              left: 50%;
              right: auto;
              bottom: auto;
              transform: translate(-50%, -50%);
            }
          }

          .swiper-button-prev {
            &::before {
              background: url('../../assets/image/elementGraph/swiper-prev.png') no-repeat center/cover;
            }

            &:hover::before {
              background: url('../../assets/image/elementGraph/swiper-prev-active.png') no-repeat center/cover;
            }
          }

          .swiper-button-next {
            &::before {
              background: url('../../assets/image/elementGraph/swiper-next.png') no-repeat center/cover;
            }

            &:hover::before {
              background: url('../../assets/image/elementGraph/swiper-next-active.png') no-repeat center/cover;
            }
          }

          .swiper-pagination .swiper-pagination-bullet {
            width: 6px;
            height: 6px;
            background: #dbd3cf;
            border-radius: 50%;
            margin: 0 4px;

            &.swiper-pagination-bullet-active {
              background: #dd363a;
            }
          }
        }
      }

      .block-content {
        margin-top: 12px;

        .swiper-slide {
          transition: all 0.5s;
          width: 138px !important;
          height: 78px !important;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
          color: #b60e0f;
          line-height: 20px;

          &.one,
          &[data-swiper-slide-index='0'],
          &:nth-child(1) {
            background: url('../../assets/image/elementGraph/cover/one.jpg') no-repeat center;
            background-size: 100% auto;
          }

          &.two,
          // &[data-swiper-slide-index='1'],
          &:nth-child(2) {
            background: url('../../assets/image/elementGraph/cover/two.jpg') no-repeat center;
            background-size: 100% auto;
          }

          &.three,
          // &[data-swiper-slide-index='2'],
          &:nth-child(3) {
            background: url('../../assets/image/elementGraph/cover/three.jpg') no-repeat center;
            background-size: 100% auto;
          }

          &.four,
          // &[data-swiper-slide-index='3'],
          &:nth-child(4) {
            background: url('../../assets/image/elementGraph/cover/four.jpg') no-repeat center;
            background-size: 100% auto;
          }

          &.five,
          // &[data-swiper-slide-index='4'],
          &:nth-child(5) {
            background: url('../../assets/image/elementGraph/cover/five.jpg') no-repeat center;
            background-size: 100% auto;
          }

          &.six,
          // &[data-swiper-slide-index='5'],
          &:nth-child(6) {
            background: url('../../assets/image/elementGraph/cover/six.jpg') no-repeat center;
            background-size: 100% auto;
          }
        }
      }
    }

    .alzy-box {
      margin-top: 25px;

      .block-content {
        margin-top: 12px;
      }

      .kcszal_item {
        display: flex;
        margin-bottom: 16px;
        width: 100%;
        padding-bottom: 16px;
        border-bottom: 1px solid #f2f2f2;
        cursor: pointer;

        &:hover {
          .item_img div {
            transform: scale(1.1);
          }

          .item_info .item_title {
            color: #cf0d04;
          }
        }

        .item_img {
          overflow: hidden;
          position: relative;
          transition: all 0.3s;
          width: 138px;
          height: 78px;
          flex-shrink: 0;

          &:hover div {
            transition: all 0.3s;
          }

          div {
            width: 100%;
            height: 100%;
            transition: all 0.3s;
            background-size: cover;
            background-position: center;
          }

          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
          }
        }

        .item_info {
          overflow: hidden;
          flex: 1;
          margin-left: 14px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .item_title {
            font-size: 14px;
            font-weight: bold;
            color: #3a3a3a;
            line-height: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top: 4px;
          }

          .item_keyword {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            background: #fff7f7;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            color: #be7f6e;
            padding-left: 10px;
          }
        }
      }
    }

    .item-text {
      margin-bottom: 18px;

      .block-content {
        margin-top: 8px;
        width: 100%;
        background: #f7f8fd;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        padding: 13px 18px;

        &:has(.wordCloud) {
          background: transparent;
          padding: 0;
        }

        .wordCloud {
          width: 100%;
          height: 300px;
        }
      }
    }
  }
}

/deep/ .ant-tooltip {
  max-width: 100%;

  .ant-tooltip-arrow::before {
    background: #fff;
    box-shadow: -3px -3px 7px rgba(103, 106, 110, 0.24);
  }

  .ant-tooltip-inner {
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(103, 106, 110, 0.24);
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    padding: 9px 15px;
    border-radius: 0;
  }
}

/deep/ .login-sub-box {
  z-index: 1001 !important;
  background: #fff;
}

.loading-wrapper {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1002;

  .ant-spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 14px;
    color: #dd363a;
  }
}

/deep/ .login-outer-box {
  z-index: 1002;
}

// 火狐浏览器滚动条样式
@-moz-document url-prefix() {
  .scroll {
    scrollbar-width: thin;
  }
}

/deep/ .ant-modal-header,
/deep/ .ant-modal-content {
  border-radius: 0;
}

/deep/ .ant-modal-body {
  padding: 24px 24px 0;
}

/deep/.relation-graph .rel-toolbar {
  display: flex;
  align-items: center;
  top: auto;
  right: auto;
  left: 18px;
  width: auto;
  border-radius: 0;
  background: #fff;
  border: none;
  box-shadow: none;
  position: fixed !important;
  bottom: 58px !important;
  transform: translate(0) !important;

  &>div {
    width: 40px;

    &:last-child {
      display: none;
    }
  }
}

.toggle-layout {
  position: fixed;
  z-index: 1000;
  display: flex;
  align-items: center;
  left: 322px;
  bottom: 58px;
  background: #fff;
  border: none;
  box-shadow: none;
  height: 46px;
  line-height: 46px;

  &.layoutType-2 {
    left: 284px;
  }

  &::before {
    content: '';
    display: inline-block;
    width: 1px;
    height: 16px;
    background: #ebebef;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .toggle-item {
    height: 100%;
    padding: 0 22px;
    cursor: pointer;
    font-size: 16px;
    color: #484848;

    &.active,
    &:hover {
      background: #fff5f5;
      color: #dd363a;
    }
  }
}
</style>

<style lang="less">
.nhljPreview {
  .ant-modal {
    width: 100vw !important;
    height: 100vh !important;
    position: fixed;
    top: 0;
    left: 0;
    padding: 0;
    margin: 0;

    iframe {
      height: calc(100vh - 78px);
    }
  }
}

.graph-select-drop {
  border-radius: 0;

  .ant-select-dropdown-menu-item:not(:has(.ant-empty)) {
    font-size: 14px;
    color: #484848;
    line-height: 35px;
    height: 35px;
    padding: 0 15px;
  }

  .ant-select-dropdown-menu-item-disabled {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  .ant-select-dropdown-menu-item-active,
  .ant-select-dropdown-menu-item:focus,
  .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled),
  .ant-select-dropdown-menu-item-selected {
    font-size: 14px !important;
    color: #a82822 !important;
    background: #fff3f2 !important;
    position: relative;
    border-bottom: 1px solid #fff;
  }
}

// 隐藏侧边栏
.fixed-aside-box:has(+ .relation-graph-container),
.relation-graph-container+.footer-box {
  display: none;
}
</style>